// import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { IconButton, Box, useTheme } from '@mui/material';
import { useState } from 'react';

import { useChatBotDetails } from 'features/we/containers/WePage/hooks';
import { useWindowSize } from 'hooks';

import InventiveLogo from '../../assets/images/Selma_Inventive.png';
import { Inventive } from './styled';

const ChatBotPopup = ({ companyId }: { companyId: string }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const { chatbot } = useChatBotDetails(companyId);
  const { isMobile, isDesktop } = useWindowSize();

  return (
    <>
      <IconButton
        onClick={togglePopup}
        style={{
          position: 'fixed',
          bottom: isMobile ? '64px' : '32px',
          right: isMobile ? '8px' : '32px',
          backgroundColor: theme.palette.info.light,
          color: 'white',
          padding: '16px',
          borderRadius: '50%',
          boxShadow: `0 4px 6px ${theme.palette.primary.p010}`,
          zIndex: 1000,
          width: isDesktop ? 120 : 80,
          height: isDesktop ? 120 : 80,
          overflow: 'hidden',
        }}
      >
        <img
          src={InventiveLogo}
          alt="Selma Logo"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%', // Ensures the image itself is also circular
          }}
        />
      </IconButton>

      {isOpen && (
        <Box
          sx={{
            position: 'fixed',
            bottom: isMobile || isDesktop ? '140px' : '110px',
            right: isMobile ? '16px' : '32px',
            width: isMobile ? '90%' : isDesktop ? '30%' : '450px',
            height: '80%',
            backgroundColor: 'white',
            boxShadow: 4,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            zIndex: 1000,
          }}
        >
          <IconButton
            onClick={togglePopup}
            style={{
              position: 'absolute',
              backgroundColor: '#007bff',
              top: '-16px',
              right: '-12px',
              color: '#fff',
              zIndex: 1000,
            }}
          >
            <KeyboardArrowDownIcon />
          </IconButton>

          <Inventive id="iframe" src={chatbot?.url} title="Iris Chat Widget"></Inventive>
        </Box>
      )}
    </>
  );
};

export default ChatBotPopup;
